import {Common, ictAxios as axios} from "@plm/o10-share-front";
import {instance} from "@posco/posco-shared";

class O10g014112Repository {

  @instance
  static instance;

  readOnly = "/o10rq0-readonly/o10g014112";
  apiUrl = "/o10g01-invcommon/o10g014111";

  axiosConfig = {
    headers: {
      "Content-Type": "application/json"
    }
  };



  /**
   * 개인정보 변경
   */
  change(data) {
    return axios.post(`${this.apiUrl}/info`, data)
      .then(response => response);
  }

  /**
   * 로컬피씨이미지업로드
   */
  profile(formData) {
    return axios.post(`${this.apiUrl}/profile/${Common.PotalUtil.getStorageItem("gcsCompCode")}/${Common.PotalUtil.getStorageItem("Posco.auth.userInfo").smrtNoteUserId}`, formData, {headers: {"Content-Type": "multipart/form-data"}})
      .then(response => response);
  }

  /**
   * 예시 이미지중 선택
   */
  profile2(path) {
    const data = {path: path};
    return axios.post(`${this.apiUrl}/profile2/${Common.PotalUtil.getStorageItem("gcsCompCode")}/${Common.PotalUtil.getStorageItem("Posco.auth.userInfo").smrtNoteUserId}`, data)
      .then(response => response);
  }
}

export default O10g014112Repository;
